import Boton from './Boton'
import BotonFavorito from './BotonFavorito'
import Enlace from './Enlace'
import IconoWhatsapp from './IconoWhatsapp'
import ImagenConFallback from './ImagenConFallback'
import { formatearPrecio } from '../lib/formato'

function TarjetaProducto({ producto, onPedir, pidiendo = false, prioridad = false }) {
  const { id, nombre, descripcion, precio, imagenUrl, disponible, permiteReproductor, origen } = producto
  const agotado = disponible === false
  const hrefDetalle = `/producto/${id}`

  // h-full: sin esto la tarjeta no se estira a la altura de su fila y el
  // mt-auto del precio no tendría espacio sobrante que repartir.
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-sm border border-oro-profundo/30 bg-carbon transition-colors duration-300 hover:border-oro-profundo">
      <div className="relative overflow-hidden">
        <Enlace href={hrefDetalle} className="block" aria-label={`Ver detalle de ${nombre}`}>
          <ImagenConFallback
            src={imagenUrl}
            alt={nombre}
            prioridad={prioridad}
            className="aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
          {agotado && (
            <div className="absolute inset-0 flex items-center justify-center bg-noche/70">
              <span className="border border-oro-profundo px-4 py-2 text-xs uppercase tracking-[0.2em] text-oro-claro">
                Reservado
              </span>
            </div>
          )}
        </Enlace>

        <BotonFavorito
          producto={producto}
          className="absolute top-2 right-2 rounded-full bg-noche/60 text-marfil backdrop-blur-sm"
        />
      </div>

      <div className="flex flex-1 flex-col p-4 sm:p-5">
        <h3 className="font-display text-base leading-snug text-marfil sm:text-lg">
          <Enlace href={hrefDetalle} className="hover:text-oro-claro">
            {nombre}
          </Enlace>
        </h3>

        {/* En la pestaña "Nuestros gatos" esto nunca aparece; solo es
            relevante si en algún momento ambos catálogos se listan juntos. */}
        {origen === 'alianza' && (
          <p className="mt-1 text-[0.65rem] uppercase tracking-[0.15em] text-marfil-suave/60">
            Gato de alianza
          </p>
        )}

        {descripcion && (
          <p className="mt-2 line-clamp-3 text-sm text-marfil-suave/80">
            {descripcion}
          </p>
        )}

        {/* mt-auto empuja el precio y el botón al fondo: con tarjetas de
            distinta longitud de descripción en la misma fila, así los botones
            quedan alineados en vez de a alturas distintas. */}
        <p className="mt-auto pt-4 font-display text-xl text-oro-claro">
          {formatearPrecio(precio)}
        </p>

        {/* La elección entre esterilizado/reproductor (y su precio) vive en
            la ficha del producto, donde hay espacio para explicarla; aquí
            solo se avisa que existe, para no forzar esa decisión desde la
            tarjeta del catálogo. */}
        {permiteReproductor && (
          <p className="mt-1 text-xs text-marfil-suave/60">
            También disponible como reproductor
          </p>
        )}

        <Boton
          className="mt-4 w-full sm:mt-5"
          onClick={() => onPedir(id)}
          disabled={agotado || pidiendo}
          aria-label={`Preguntar por ${nombre} en WhatsApp`}
        >
          {pidiendo ? (
            'Abriendo WhatsApp…'
          ) : (
            <>
              <IconoWhatsapp />
              Preguntar por WhatsApp
            </>
          )}
        </Boton>
      </div>
    </article>
  )
}

export default TarjetaProducto
